<template>
<div class="panelNagusia">
  <div class="ui breadcrumb">
    <a class="section" v-on:click="goTo('/dashboard')">Home</a>
    <i class="right angle icon divider"></i>
    <a class="active" v-on:click="goTo('/corporations')">Corporaciones</a>
    <i class="right angle icon divider"></i>
    <a class="active section">Paquetes</a>
  </div>
  <h1 class="ui header"><img class="ui image" src="../../assets/parcels.png">
    <div class="content">Paquetes</div>
  </h1>
  <div v-if="rows.length==0" class="ui active centered inline loader"></div>
  <div v-if="rows.length!=0" class="ui stackable one column divided grid container">
    <div class="row">
      <div class="column">
        <h4 class="ui dividing header">Los últimos movimientos</h4>
        <vue-good-table :columns="columns" :rows="rows" :lineNumbers="true" :pagination-options="{
                perPage: 50,
                enabled: true,
                mode: 'pages'
                }" :sort-options="{
                enabled: true,
                initialSortBy: {field: 'lastUpdate', type: 'desc'}
                }"
          @on-row-click="parcelInfo" styleClass="vgt-table striped condensed bordered">
          >
        </vue-good-table>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import { hapiickApi } from '@/api/hapiickApi';
export default {
  name: 'corporationParcels',
  props: ['id'],
  data() {
    return {
      search: {
        'phone': null,
        'barcode': null,
        'refcode': null
      },
      columns: [{
          label: 'Cliente',
          field: 'from',
          filterOptions: {
            placeholder: 'Cliente',
            enabled: true, // enable filter for this column
            trigger: 'enter', //only trigger on enter not on keyup
          }
        },
        {
          label: 'Teléfono',
          field: 'phone',
          filterOptions: {
            placeholder: 'Teléfono',
            enabled: true, // enable filter for this column
            trigger: 'enter', //only trigger on enter not on keyup
          }
        },
        {
          label: 'Email',
          field: 'email',
          filterOptions: {
            placeholder: 'Email',
            enabled: true, // enable filter for this column
            trigger: 'enter', //only trigger on enter not on keyup
          }
        },
        {
          label: 'Barcode',
          field: 'barcode',
          filterOptions: {
            placeholder: 'Barcode',
            enabled: true, // enable filter for this column
            trigger: 'enter', //only trigger on enter not on keyup
          }
        },
        {
          label: 'APM',
          field: 'apm',
          filterOptions: {
            placeholder: 'APM',
            enabled: true, // enable filter for this column
            trigger: 'enter', //only trigger on enter not on keyup
          }
        },
        {
          label: 'Estado',
          field: 'status',
          filterOptions: {
            placeholder: 'Estado',
            enabled: true, // enable filter for this column
            trigger: 'enter', //only trigger on enter not on keyup
          }
        },
        {
          label: 'Ult. Actualización',
          field: 'lastUpdate',
          width: '120px',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd HH:mm:ss',
          dateOutputFormat: 'yyyy-MM-dd HH:mm:ss',
        }
      ],
      rows: [],
    }
  },
  created() {
    let role = JSON.parse(localStorage.admin).role
    if (role === 'master' || role === 'admin' || role === 'hmyCorporate') {
      this.getCoporationParcels()
    } else {
      this.$router.replace('/parcels_v2')
    }
  },
  methods: {
    getCoporationParcels() {
      hapiickApi().post('/v1/corporations/shipments', {
        admin_id: JSON.parse(localStorage.admin).id,
        corp_id: this.id
      })
      .then(request => this.updateTable(request))
      .catch(() => console.log('error getting corpo parcels'))
    },
    updateTable(req) {
      let parcels = []
      parcels = JSON.parse(JSON.stringify(req.data.data.parcels))
      if (parcels.length == 0) {
        console.log('no data');
        this.rows.push({
          'from': 'no encontrado',
        })
      }
      for (var i in parcels) {
        let element = parcels[i]
        this.rows.push({
          'from': element.from,
          'phone': element.phone,
          'email': element.email,
          'barcode': element.barcode,
          'destination': element.destination,
          'apm': element.destination,
          'status': element.status,
          'lastUpdate': element.lastUpdate,
          'id': element.id
        })
      }
    },
    goTo(where) {
      this.$router.push(where)
    },
    parcelInfo(params) {
      let routeData = this.$router.resolve('/parcels_v2/info/' + params.row.from + '/' + params.row.id);
      window.open(routeData.href, '_blank');
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Corporations/corporationParcels.vue